<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMainServer :datatable="tableServer" :on-success="successTableAction" :itemsAction="successTableAction"
          :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <!-- <DataTable :datatable='table' :on-success='successAction' :itemsAction='tableAction' /> -->
      </v-col>
      <v-col cols="12">
        <ViewDetails class="ma-2" :object="object" type="EmployeeDtail" :itemsAction="successTableAction"/>
      </v-col>
    </v-row>
    <EmpleadoMainDialog v-if="get_dialogMain.dialog && dialogs.empleados" :model="empleado" :params="paramsDialog" />
    <AdscripcionMainDialog v-if="get_dialogMain.dialog && dialogs.adscripciones" :model="empleado" :params="paramsDialog" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTableMainServer from '@/components/tables/DataTableMainServer'

import EmpleadoMainDialog from '@/components/dialogs/empleado/EmpleadoMainDialog'
import AdscripcionMainDialog from '@/components/dialogs/adscripcion/AdscripcionMainDialog'

import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    tableServer: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      itemKey: 'cve_empleado',
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'rh.execute.create-empleado' }
        ],
        titles: [
          { text: 'Clave Empleado', value: 'cve_empleado', class: 'black--text' },
          { text: 'Nombre Completo', value: 'NombreCompleto', class: 'black--text' },
          { text: 'RFC', value: 'rfc', class: 'black--text' },
          { text: 'CURP', value: 'curp', class: 'black--text' },
          { text: 'Fecha Ingreso', value: 'observaciones.fecha_alta', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'rh.empleados-update' },
          { title: 'Cargar Imagen', icon: 'mdi-camera-burst', color: 'primary darken-3', action: 'loadImageData', code: 'rh.empleados-load-image' }
        ],
        totalData: 0,
        pagination: {}
      },
      footer: {
        paging: true
      }
    },
    dialogs: {
      empleados: false,
      adscripciones: false,
      cuentas: false
    },
    item: {},
    params: {},
    empleado: {},
    paramsDialog: {
      form: {},
      url: {},
      message: ''
    }
  }),
  components: {
    DataTableMainServer,
    EmpleadoMainDialog,
    AdscripcionMainDialog,
    ViewDetails
  },
  mounted () {
    // this.getUrl('POST/rh/empleados/pagination/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableServer })
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServicePaginationAction', 'postServiceListAction']),
    // *==========*==========*==========* Methods Table Pagination *==========*==========*==========* \\
    pagePagination (val) {
      this.tableServer.header.loading = true
      this.params = val
      this.getUrl('POST/rh/empleados/pagination/show')
    },
    getSearchPagePagination (val) {
      this.tableServer.header.loading = true
      val.page = 1
      this.params = val
      this.getUrl('POST/rh/empleados/pagination/search/show')
    },
    /* *==========*==========*==========*==========*==========* */
    successTableAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.tableServer.header.loading = true
      this.getUrl('POST/rh/empleados/pagination/show')
    },
    newData (item) {
      this.dialogs = { empleados: true, adscripciones: false, cuentas: false }
      this.empleado = {}
      this.paramsDialog = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 800, title: 'Nuevo Colaborador' })
    },
    updateData ({ item }) {
      this.dialogs = { empleados: true, adscripciones: false, cuentas: false }
      this.empleado = item
      this.paramsDialog = { update: true }
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 800, title: 'EDITAR COLABORDOR' })
    },
    loadImageData ({ item }) {
      this.dialogs = { empleados: true, loadImage: true }
      this.empleado = { cve_empleado: item.cve_empleado, NombreCompleto: item.NombreCompleto }
      this.paramsDialog = {
        form: this.get_loadImageForm,
        formData: true,
        url: this.get_urls['POST/rh/empleados/image'],
        message: 'Registro Agregado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 800, title: 'EDITAR COLABORDOR' })
    },
    newAdscripcionData ({ item }) {
      this.dialogs = { adscripciones: true }
      this.empleado = {
        empleado: { cve_empleado: item.cve_empleado, NombreCompleto: item.NombreCompleto }
      }
      this.paramsDialog = { reload: true }
      // process
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 800, title: 'ASIGNAR ADSCRIPCION' })
    },
    updateAdscripcionData ({ item }) {
      // console.log('item', item)
      this.dialogs = { empleados: false, adscripciones: true, cuentas: false }
      this.empleado = item
      this.paramsDialog = { reload: true, update: true }
      // process
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 800, title: 'EDITAR ADSCRIPCION' })
    },
    newCuentaData ({ item }) {
      this.dialogs = { empleados: true, cuentas: true }
      this.empleado = {
        empleado: { cve_empleado: item.cve_empleado, NombreCompleto: item.NombreCompleto }
      }
      const cuentasEmpleadosForm = this.get_cuentasEmpleadosForm
      cuentasEmpleadosForm.map(item => {
        if (item.field === 'searchDataServer' && item.nameid === 'cve_empleado') {
          item.readonly = true
        }
      })
      this.paramsDialog = {
        form: cuentasEmpleadosForm,
        url: this.get_urls['POST/nomina/cuentas/new'],
        message: 'Registro Agregado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 850, title: 'Nueva Cuenta' })
    },
    updateCuentaData ({ item }) {
      this.dialogs = { empleados: true, cuentas: true, update: true }
      this.empleado = item
      const cuentasEmpleadosForm = this.get_cuentasEmpleadosForm
      cuentasEmpleadosForm.map(item => {
        if (item.field === 'searchDataServer' && item.nameid === 'cve_empleado') {
          item.readonly = true
        }
      })
      this.paramsDialog = {
        form: cuentasEmpleadosForm,
        url: this.get_urls['POST/nomina/cuentas/new'],
        message: 'Registro actualizado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 850, title: 'Editar Cuenta' })
    },
    newContactoData ({ item }) {
      this.dialogs = { empleados: true, contacto: true }
      this.empleado = { empleado: { cve_empleado: item.cve_empleado, NombreCompleto: item.NombreCompleto } }
      const contactoForm = this.get_contactoForm
      contactoForm.map(item => {
        if (item.field === 'searchDataServer' && item.nameid === 'cve_empleado') {
          item.readonly = true
        }
      })
      this.paramsDialog = {
        url: this.get_urls['POST/rh/empleado/contacto/store'],
        form: contactoForm,
        message: 'Registro Agregado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 700, title: 'Agregar contacto' })
    },
    newDireccionData ({ item }) {
      this.dialogs = { empleados: true, direccion: true }
      this.empleado = { empleado: { cve_empleado: item.cve_empleado, NombreCompleto: item.NombreCompleto } }
      const direccionForm = this.get_direccionForm
      direccionForm.map(item => {
        if (item.field === 'searchDataServer' && item.nameid === 'cve_empleado') {
          item.readonly = true
        }
      })
      this.paramsDialog = {
        url: this.get_urls['POST/rh/empleado/direccion/store'],
        form: direccionForm,
        message: 'Registro Agregado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 700, title: 'Agregar Direccion' })
    },
    updateDireccionData ({ item }) {
      this.dialogs = { empleados: true, direccion: true, update: true }
      this.empleado = item
      const direccionForm = this.get_direccionForm
      direccionForm.map(item => {
        if (item.field === 'searchDataServer' && item.nameid === 'cve_empleado') {
          item.readonly = true
        }
      })
      this.paramsDialog = {
        url: this.get_urls['POST/rh/empleado/direccion/store'],
        form: direccionForm,
        message: 'Registro Agregado Correctamente',
        reload: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'general', with: 700, title: 'Editar Direccion' })
    },
    /* *==========*==========* */
    addDocument (item) {
      this.empleado = item
      this.SHOW_DIALOG_MAIN({ type: 'addDocument', with: 600, title: 'Agregar Documentacion' })
    },
    authorization (item) {
      this.empleado = item
      this.SHOW_DIALOG_MAIN({ type: 'authorization', with: 700, title: `AUTORIZA A ${item.item.NombreCompleto}` })
    },
    initialContract (item) {
      this.empleado = item
      this.SHOW_DIALOG_MAIN({ type: 'initialContract', with: 700, title: 'CONTRATO INICIAL' })
    },
    contractTerm (item) {
      this.empleado = item
      this.SHOW_DIALOG_MAIN({ type: 'contractTerm', with: 700, title: 'FIN DE CONTRATO' })
    },
    termOfWorkContract (item) {
      this.empleado = item
      this.SHOW_DIALOG_MAIN({ type: 'termOfWorkContract', with: 700, title: 'FIN DE CONTRATO (BAJA DEL EMPLEADO)' })
    },
    /* *==========*==========* */
    toLowAdscripcion (item) {
      this.dialogs = { adscripciones: true }
      this.empleado = item
      this.paramsDialog = { reload: true }
      this.SHOW_DIALOG_MAIN({ type: 'lowAdscripcion', with: 500, title: 'BAJA DE ADSCRIPCION' })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServicePaginationAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_reload',
      'get_contactoForm', 'get_direccionForm', 'get_cuentasEmpleadosForm', 'get_loadImageForm']),
    object () {
      if (this.tableServer.modelMain.length > 0) {
        return this.tableServer.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls () {
      this.getUrl('POST/rh/empleados/pagination/show')
    },
    get_objectPagination (vals) {
      if (vals) {
        this.tableServer.modelMain = []
        if (vals.data.length > 0) {
          this.tableServer.modelMain.push(vals.data[0])
        }
        this.tableServer.body.data = vals.data
        this.tableServer.body.totalData = vals.total
        this.tableServer.header.loading = false
      }
    },
    get_reload (val) {
      if (val) {
        if (this.dialogs.adscripciones) {
          this.tableServer.body.data.map(item => {
            if (item.cve_empleado === val.cve_empleado) {
              let findobject = -1
              item.adscripciones.map((ads, i) => {
                if (ads.id === val.id) {
                  findobject = i
                }
              })
              if (findobject !== -1) {
                Object.assign(item.adscripciones[findobject], val)
              } else {
                item.adscripciones.push(val)
              }
            }
          })
        } else if (this.dialogs.empleados) {
          if (this.dialogs.cuentas) {
            this.tableServer.body.data.map(item => {
              if (item.cve_empleado === val.cve_empleado) {
                item.cuentas_bancarias.push(val)
              }
            })
          } else if (this.dialogs.direccion) {
            if (this.dialogs.update) {
              this.tableServer.body.data.map(item => {
                if (item.cve_empleado === val.cve_empleado) {
                  let findobject = -1
                  item.direcciones.map((direc, i) => {
                    if (direc.id === val.id) {
                      findobject = i
                    }
                  })
                  if (findobject !== -1) Object.assign(item.direcciones[findobject], val)
                }
              })
              return
            }
            this.tableServer.body.data.map(item => {
              if (item.cve_empleado === val.cve_empleado) {
                item.direcciones.push(val)
              }
            })
          } else if (this.dialogs.contacto) {
            this.tableServer.body.data.map(item => {
              if (item.cve_empleado === val.cve_empleado) {
                item.contactos.push(val)
              }
            })
          } else if (this.dialogs.loadImage) {
            this.tableServer.body.data.map(item => {
              if (item.cve_empleado === val.cve_empleado) {
                item.foto = val.foto
                item.FotoString = val.fotoString
              }
            })
          } else {
            this.tableServer.body.data.push(val)
          }
        }
      }
    }
  }
}
</script>

<style></style>
